<template>
  <div
    class="appointment d-flex flex-column justify-content-start align-items-start"
  >
    <Card
      headless
      class="full-width shadow-none"
      :class="{ highlighted: isSelected }"
    >
      <template #body>
        <div class="appointment-container">
          <div class="appt-header mb-2">
            <h4 class="appt-title font-normal mr-2">
              <b>{{ title }}</b> - #{{ appointment.id }}
            </h4>

            <div>
              <AppointmentActions
              view-on-schedule
              :appointment="appointment"
              :customer="customer"
              @save-success="refreshJob"
            >
              <template #trigger>
                <div
                  class="d-flex align-items-center link"
                  data-cy="appointment-actions-trigger"
                >
                  <i class="far fa-list-radio mr-2"></i>
                  Options
                </div>
              </template>
            </AppointmentActions>
            </div>
          </div>
          <appointment-header :appointment="appointment" />
          <div class="overflow-auto">
            <times-and-crew :appointment="appointment" />
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";
import { getQueryVariables } from "@/lib/url.js";

import Card from "@/components/Card.vue";
import CONSTANTS from "@/Constants.js";
import AppointmentActions from "@/Job/AppointmentActions.vue";
import AppointmentHeader from "@/Job/AppointmentCard/AppointmentHeader.vue";
import TimesAndCrew from "@/Job/AppointmentCard/TimesAndCrew.vue";

export default {
  components: {
    Card,
    AppointmentHeader,
    TimesAndCrew,
    AppointmentActions
  },
  props: {
    appointment: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isSelected: false
    };
  },
  computed: {
    title() {
      return this.appointment.service_category.name;
    },
    scheduleDate() {
      // Get appointment scheduled date in correct format for schedule board
      return moment(this.appointment.scheduled_time).format(
        CONSTANTS.DATE_YEAR_CAL_FORMAT
      );
    }
  },
  mounted() {
    const { appointment_id } = getQueryVariables();
    this.isSelected = appointment_id && appointment_id == this.appointment.id;
  },
  methods: {
    refreshJob() {
      EventBus.$emit("refresh-job");
    }
  }
};
</script>

<style lang="scss" scoped>
.view-on-schedule {
  padding-right: 16px;
}

.appointment {
  width: 100%;
  margin-bottom: 1rem;
}

.appointment-container {
  display: flex;
  flex-direction: column;
}

.appt-header {
  display: flex;
  justify-content: space-between;
  span {
    font-size: 1rem;
  }
  h4 {
    display: inline-block;
  }
}

.highlighted {
  box-shadow: none;
  border: 3px solid var(--sera-color-fields-active);
}
</style>
